import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Menu from "./Components/Menu";
import Header from "./Components/Header";
import { config } from "./Components/Config";

const GENDER_LABEL = { MR: "Tuan", MRS: "Nyonya", MISS: "Nona" };

const EventContactDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [contact, setContact] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchContact();
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchContact = async () => {
    setIsLoading(true);
    try {
      const res = await fetch(`${config.EVENT_ENDPOINT}contact/${id}`);
      const result = await res.json();
      if (result.success) setContact(result.data);
    } catch (err) {
      console.error("Error fetching contact:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const Field = ({ label, value }) => (
    <div className="col-md-6">
      <label className="form-label text-secondary fw-semibold mb-2">{label}</label>
      <input type="text" value={value || "-"} disabled className="form-control p-2 bg-light" />
    </div>
  );

  const FieldFull = ({ label, value }) => (
    <div className="col-md-12">
      <label className="form-label text-secondary fw-semibold mb-2">{label}</label>
      <input type="text" value={value || "-"} disabled className="form-control p-2 bg-light" />
    </div>
  );

  return (
    <div id="event-contact-detail">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard">
                <img className="h-100" src="/cuancuan.png" alt="PointStar" />
              </a>
            </div>
            <hr className="m-0" />
            <Menu active="event-contact" />
          </div>

          <div className="col-md-10 flex-grow-1">
            <Header />
            <hr className="m-0" />
            <div className="main">
              <div className="p-4">
                <div className="d-flex align-items-center text-secondary mb-4">
                  <span style={{ cursor: "pointer" }} onClick={() => navigate("/event/contact")}>
                    Contact
                  </span>
                  <i className="bi bi-chevron-right mx-2 fs-6" />
                  <span className="text-dark">Detail Contact</span>
                </div>

                <h3 className="fw-bold mb-4">Detail Contact</h3>

                {isLoading ? (
                  <p>Loading...</p>
                ) : !contact ? (
                  <div className="text-center p-4 text-secondary">Contact tidak ditemukan.</div>
                ) : (
                  <div className="bg-white rounded-3 shadow-sm p-4">
                    <div className="row g-4">
                      <FieldFull label="Nama Lengkap" value={contact.name} />

                      <Field label="Sapaan" value={contact.gender ? GENDER_LABEL[contact.gender] : null} />
                      <Field label="No. Telepon (WhatsApp)" value={contact.phone} />

                      <FieldFull label="Email" value={contact.email} />
                      <FieldFull label="Nama Perusahaan" value={contact.company} />

                      <Field label="Posisi" value={contact.position} />
                      <Field label="Industri" value={contact.industry} />

                      <FieldFull label="Departemen" value={contact.department} />
                      <FieldFull label="Tingkat Pengambilan Keputusan" value={contact.procurementRole} />
                      <FieldFull label="Sumber" value={contact.source} />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventContactDetail;
